import { Component, Input } from '@angular/core';
import { IPage } from '../../models/common/paging';
import { AwardDto, CompetitorAwardsSearchModel } from '../../models/competitors/competitor.models';

@Component({
    selector: 'competitor-awards-table',
    template: require('./competitor.awards.table.component.html')
})
export class CompetitorAwardsTableComponent {
    @Input() results: IPage<AwardDto>;
    @Input() request: CompetitorAwardsSearchModel;
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/competitors/competitor.awards.table.component.ts